import {
  Box,
  Column,
  Columns,
  Heading,
  IconFilter,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import type { FC, ReactNode } from 'react';
import { FilterClearButton } from './FilterClearButton';
import type { FilterFns } from './useFilters';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

interface FilterSideBarProps {
  selectedFilterCount: number;
  resetFilters: FilterFns['resetFilters'];
  filters: ReactNode;
}

export const FilterSideBar: FC<FilterSideBarProps> = ({
  selectedFilterCount,
  resetFilters,
  filters,
}) => {
  const { t } = useTranslations(translations);
  return (
    <Box background="surface" padding="gutter" paddingTop="large">
      <Stack space="large">
        <Columns space="small">
          <Column>
            <Heading level="3">
              <Inline space="xsmall" alignY="center">
                <IconFilter />
                <Text data={{ intercomid: 'byFilters' }}>{t('Filters')}</Text>
              </Inline>
            </Heading>
          </Column>
          <Column width="content">
            {selectedFilterCount > 0 ? (
              <FilterClearButton resetFilters={resetFilters} />
            ) : null}
          </Column>
        </Columns>
        <>{filters}</>
      </Stack>
    </Box>
  );
};
